import type { $TSFixMe } from '@calefy-inc/utilityTypes';

interface QuoteWizardQuoteInput {
  [k: string]: $TSFixMe;
}

export class QuoteWizardQuote {
  [k: string]: $TSFixMe;

  constructor(input: QuoteWizardQuoteInput) {
    Object.entries(input).forEach(([k, v]) => {
      this[k] = v;
    });
  }
}
